/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

/* =========================================================
   Grow Me Educators Program - $250 basket limit
   Applies ONLY to logged-in customers with the
   `educator-verified` customer tag.
   ========================================================= */
(function () {
  'use strict';

  if (!window.GrowMeEducator || !window.GrowMeEducator.isEducator) return;

  var LIMIT_CENTS = 25000;
  var LIMIT_TEXT = '$250';
  var NOTICE_ID = 'growme-educator-cart-limit-notice';
  var originalFetch = window.fetch.bind(window);
  var checkingAdd = false;

  function money(cents) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD'
      }).format(cents / 100);
    } catch (e) {
      return LIMIT_TEXT;
    }
  }

  function showNotice(message) {
    var existing = document.getElementById(NOTICE_ID);
    if (existing) existing.remove();

    var notice = document.createElement('div');
    notice.id = NOTICE_ID;
    notice.setAttribute('role', 'alert');
    notice.setAttribute('aria-live', 'polite');
    notice.innerHTML = '<div class="growme-educator-limit__inner"><strong>Educators Program basket limit</strong><span>' + message + '</span><button type="button" aria-label="Close">&times;</button></div>';

    var style = document.createElement('style');
    style.textContent = '#'+NOTICE_ID+'{position:fixed;left:50%;top:24px;transform:translateX(-50%);z-index:99999;max-width:min(92vw,560px);width:max-content;background:#294f4b;color:#fff;border-radius:8px;box-shadow:0 8px 30px rgba(0,0,0,.18);padding:0;font-family:inherit}#'+NOTICE_ID+' .growme-educator-limit__inner{display:flex;align-items:center;gap:12px;padding:15px 18px}#'+NOTICE_ID+' strong{font-weight:600;white-space:nowrap}#'+NOTICE_ID+' span{line-height:1.4}#'+NOTICE_ID+' button{border:0;background:none;color:inherit;font-size:24px;line-height:1;cursor:pointer;padding:0 0 2px 8px}';
    notice.appendChild(style);
    document.body.appendChild(notice);
    notice.querySelector('button').addEventListener('click', function () { notice.remove(); });
    window.setTimeout(function () { if (notice.parentNode) notice.remove(); }, 6500);
  }

  function getCart() {
    return originalFetch(theme.routes.cart_url + '.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function getVariantPrice(variantId) {
    return originalFetch('/variants/' + encodeURIComponent(variantId) + '.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('Variant lookup failed');
      return r.json();
    }).then(function (variant) {
      return Math.round(parseFloat(variant.price) * 100);
    });
  }

  function parseAddBody(body) {
    var id = null;
    var quantity = 1;
    if (body instanceof FormData) {
      id = body.get('id');
      quantity = parseInt(body.get('quantity') || '1', 10) || 1;
    } else if (body instanceof URLSearchParams) {
      id = body.get('id');
      quantity = parseInt(body.get('quantity') || '1', 10) || 1;
    } else if (typeof body === 'string') {
      try {
        var params = new URLSearchParams(body);
        id = params.get('id');
        quantity = parseInt(params.get('quantity') || '1', 10) || 1;
      } catch (e) {}
    }
    return { id: id, quantity: quantity };
  }

  function isCartAdd(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var addUrl = theme.routes.cart_add_url || '/cart/add';
    return url.indexOf(addUrl) !== -1 || url.indexOf('/cart/add') !== -1;
  }

  window.fetch = function (input, init) {
    if (!isCartAdd(input, init) || checkingAdd) {
      return originalFetch(input, init);
    }

    var body = init && init.body;
    if (!body && input && typeof input !== 'string') body = input.body;
    var parsed = parseAddBody(body);
    if (!parsed.id) return originalFetch(input, init);

    checkingAdd = true;
    return Promise.all([getCart(), getVariantPrice(parsed.id)]).then(function (results) {
      var cart = results[0];
      var unitPrice = results[1];
      var proposed = (cart.total_price || 0) + (unitPrice * parsed.quantity);

      if (proposed > LIMIT_CENTS) {
        var remaining = Math.max(0, LIMIT_CENTS - (cart.total_price || 0));
        showNotice('Your basket must be ' + money(LIMIT_CENTS) + ' or below. You have ' + money(remaining) + ' remaining. This product was not added.');

        return new Response(JSON.stringify({
          status: 422,
          message: 'Educators Program baskets are limited to $250 or below.'
        }), {
          status: 422,
          headers: { 'Content-Type': 'application/json' }
        });
      }

      return originalFetch(input, init);
    }).catch(function () {
      /* If the pre-check fails, do not block a legitimate Shopify add. */
      return originalFetch(input, init);
    }).finally(function () {
      checkingAdd = false;
    });
  };

  function validateExistingCart() {
    getCart().then(function (cart) {
      if ((cart.total_price || 0) > LIMIT_CENTS) {
        showNotice('Your basket is over ' + money(LIMIT_CENTS) + '. Please remove some products before checkout.');
        document.querySelectorAll('[name="checkout"], [data-cart-checkout], .cart__checkout').forEach(function (button) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          button.dataset.growmeEducatorLimitDisabled = 'true';
        });
      }
    }).catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', validateExistingCart);
  document.addEventListener('cart:updated', validateExistingCart);
})();

